import { PairsV4 } from '@ui/services/contract/hooks/PairsManagerFacet/usePairsV4';

export const getLeverageMargin = ({
  leverage,
  leverageMargins,
}: {
  leverageMargins: PairsV4['leverageMargins'];
  leverage: number;
}) => {
  return leverageMargins
    .sort((a, b) => a.maxLeverage - b.maxLeverage)
    .find((margin) => leverage <= margin.maxLeverage);
};
